// src/ui/recorder.js
// Tiny module-level shared state for record mode. Lives in its own file
// so the Transport (which writes) and the PianoKeyboard (which reads)
// can both depend on it without a circular import.
//
// Usage:
//   import { recorder } from '../ui/recorder.js';
//   recorder.recording;            // boolean, read
//   recorder.setRecording(true);   // write, notifies subscribers
//   recorder.onChange(fn);         // subscribe to changes

import * as Tone from 'tone';

const _recorder = {
  recording: false,
  recStartTime: null,      // Tone.Transport.seconds when recording started
  pendingClip: null,       // { name, notes: [] } while a clip is being recorded
  _listeners: new Set(),

  setRecording(v) {
    const next = !!v;
    if (next === this.recording) return;
    this.recording = next;
    this._listeners.forEach((fn) => fn(next));
  },

  startClipRecording(name) {
    this.pendingClip = { name: name || 'Recorded clip', notes: [] };
    this.recStartTime = Tone.Transport.seconds;
    this.setRecording(true);
  },

  stopClipRecording() {
    this.setRecording(false);
    const clip = this.pendingClip;
    this.pendingClip = null;
    this.recStartTime = null;
    return clip;
  },

  onChange(fn) {
    this._listeners.add(fn);
    return () => this._listeners.delete(fn);
  }
};

export const recorder = _recorder;
